<template>
    <div class="comp-video-box">

    </div>
</template>

<script>
    export default {
        name: "comp-video-box"
    }
</script>

<style lang="scss" scoped>

</style>
